import { AutogenLayoutMobileCommControlNetworkManagement } from "./autogen/AutogenLayoutMobileCommControlNetworkManagement";

export class MobileCommControlNetworkManagement extends AutogenLayoutMobileCommControlNetworkManagement {

    async onLoad() {
        // Initialize network management configuration
        this.configureNetworkFields();
    }

    /**
     * Configure network management fields with validation
     */
    private configureNetworkFields() {
        // Configure server host validation
        if (this.textboxMcleodServer) {
            this.textboxMcleodServer.addChangeListener(() => {
                this.validateServerHost();
            });
        }

        // Configure port validation
        this.configurePortField(this.textboxServerPort, "Server Communication Port");
        this.configurePortField(this.textboxClientPort, "Client Connection Port");

        // Configure IP host validation
        if (this.textboxIpHost) {
            this.textboxIpHost.addChangeListener(() => {
                this.validateIpHost();
            });
        }
    }

    /**
     * Validate server host field
     */
    private validateServerHost() {
        const host = this.textboxMcleodServer.text?.trim();
        if (host && !this.isValidHostname(host)) {
            this.textboxMcleodServer.validationWarning = "Please enter a valid hostname or IP address";
        } else {
            this.textboxMcleodServer.validationWarning = null;
        }
    }

    /**
     * Validate IP host field
     */
    private validateIpHost() {
        const host = this.textboxIpHost.text?.trim();
        if (host && !this.isValidIpAddress(host)) {
            this.textboxIpHost.validationWarning = "Please enter a valid IP address";
        } else {
            this.textboxIpHost.validationWarning = null;
        }
    }

    /**
     * Configure port field validation
     */
    private configurePortField(textbox: any, fieldName: string) {
        if (textbox) {
            textbox.addChangeListener(() => {
                const port = parseInt(textbox.text);
                if (isNaN(port) || port < 1 || port > 65535) {
                    textbox.validationWarning = `${fieldName} must be between 1 and 65535`;
                } else {
                    textbox.validationWarning = null;
                }
            });
        }
    }

    /**
     * Basic hostname validation
     */
    private isValidHostname(hostname: string): boolean {
        const hostnameRegex = /^([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9\-]*[a-zA-Z0-9])\.?([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9\-]*[a-zA-Z0-9])*$/;
        return hostnameRegex.test(hostname) || this.isValidIpAddress(hostname);
    }

    /**
     * Basic IP address validation
     */
    private isValidIpAddress(ip: string): boolean {
        const ipRegex = /^(\d{1,3}\.){3}\d{1,3}$/;
        if (!ipRegex.test(ip)) return false;

        const parts = ip.split('.');
        return parts.every(part => {
            const num = parseInt(part);
            return num >= 0 && num <= 255;
        });
    }
}
